var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout"
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "text-center mt-4 mb-3"
  }, [_vm._v("選擇院所")]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoadingInstitutions || _vm.isUpdatingSelectedInstitution
    }
  }, [_c('div', {
    staticClass: "institution-list"
  }, _vm._l(_vm.availableInstitutions, function (institution) {
    return _c('button', {
      key: institution.display_name,
      staticClass: "institution-list__select-institution",
      on: {
        "click": function click($event) {
          return _vm.updateSelectedInstitution(institution);
        }
      }
    }, [_vm._v(" " + _vm._s(institution.display_name) + " ")]);
  }), 0)])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }